export default __webpack_public_path__ + "static/media/review16.88742930.jpg";